import {ListItem} from '../../layout';
import {contextProtection, join} from '../../utils';
import {ReactNode, useContext} from 'react';
import {Selectors} from '../controls.selectors';
import {SelectableListItem} from '../selectable-list/selectable-list-item';
import DropdownContext from './dropdown-context';
import styles from './dropdown.module.less';

interface Props {
	value: any;
	children: ReactNode;
	className?: string;
	onClick?: (value: any) => void;
	checked?: boolean;
	disabled?: boolean;
	title?: string;
}

export function Option(props: Props) {
	const {value, children, className, onClick, checked, disabled, title} = props;
	const context = useContext(DropdownContext);

	if(contextProtection(context, Option, DropdownContext)) {
		if (context.multiselect) {
			return <SelectableListItem className={join(styles.option, className)}
									   data-cy={Selectors.DropdownItem}
									   tabIndex={context.toggled ? 0 : -1}
									   onClick={(e) => onClick?.(value)}
									   checked={checked}
									   disabled={disabled}
									   value={value}
									   title={title}>
				{children}
			</SelectableListItem>;
		} else {
			const selected = context.currentValue.indexOf(value) > -1;
			return <ListItem className={join(styles.option, selected && styles.selected, className && className)}
							 data-cy={Selectors.DropdownItem}
							 onKeyPress={(e) => {
								 if (['enter', 'space'].indexOf(e.code.toLowerCase()) >= 0) {
									 context.onOptionClick(value);
								 }
							 }}
							 tabIndex={context.toggled ? 0 : -1}
							 onClick={(e) => context.onOptionClick(value)}>
				{children}
			</ListItem>;
		}
	}

	return null;
}

export default Option;
